import { TwoFactorProviderType } from "../../enums/twoFactorProviderType";
import { Utils } from "../../misc/utils";

export class AuthResult {
  captchaSiteKey = "";
  resetMasterPassword = false;
  isFirstDevice = false;
  deviceApprovalRequired = false;
  encryptedUserKey: string = null;
  // Account private key, used with encryptedUserKey for the TDE returning-device unlock.
  privateKey: string = null;
  forcePasswordReset = false;
  twoFactorProviders: Map<TwoFactorProviderType, { [key: string]: string }> = null;

  get requiresCaptcha() {
    return !Utils.isNullOrWhitespace(this.captchaSiteKey);
  }

  get requiresTwoFactor() {
    return this.twoFactorProviders != null;
  }
}
